import * as Sentry from '@sentry/react';

// ── HTTP API Metrics ──

export function trackApiResponseTime(endpoint: string, method: string, durationMs: number, statusCode: number) {
  Sentry.metrics.distribution('api.response_time', durationMs, {
    unit: 'millisecond',
    attributes: { endpoint, method, status_code: String(statusCode) },
  });
}

export function trackApiError(endpoint: string, method: string, statusCode: number) {
  Sentry.metrics.count('api.error', 1, {
    attributes: { endpoint, method, status_code: String(statusCode) },
  });
}

// ── Auth Metrics ──

export function trackAuthSignIn(success: boolean) {
  Sentry.metrics.count('auth.sign_in', 1, {
    attributes: { success: String(success) },
  });
}

export function trackAuthSessionExpired() {
  Sentry.metrics.count('auth.session_expired', 1);
}

// ── Page Performance Metrics ──

export function trackPageLoadTime(pageName: string, durationMs: number) {
  Sentry.metrics.distribution('page.load_time', durationMs, {
    unit: 'millisecond',
    attributes: { page: pageName },
  });
}
